import { PayloadAction } from '../../../../../store.model';
import { determinePeriod } from '../function/determine-period.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../main.action';
import { defaultState, MainState } from '../main.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: MainState,
    action: PayloadAction<ActionType.WP_MAIN__RELOAD, Reload>,
): MainState {
    const nextState: MainState = {
        ...defaultState(),
        pending: {
            ...state.pending,
            reload: true,
        },
    };
    if (action.payload.reset === true) {
        nextState.pending.reset = true;
        nextState.dataRanges = state.dataRanges;
        nextState.selectedDataRangeId = state.selectedDataRangeId;
        nextState.evalRanges = state.evalRanges;
        nextState.selectedEvalRangeId = state.selectedEvalRangeId;
        nextState.drillPaths = state.drillPaths;
        nextState.selectedDrillPathId = state.selectedDrillPathId;
    }
    return nextState;
}

export function reloadResultReducer(
    state: MainState,
    action: PayloadAction<ActionType.WP_MAIN__RELOAD_RESULT, ReloadResult>,
): MainState {
    try {
        const nextRows = sortRows(
            action.payload.table?.rows,
            state.sortOptions,
            action.payload.table,
            action.payload.config,
        );

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
                reset: undefined,
            },
            config: action.payload.config,
            table: action.payload.table,
            dataRanges: action.payload.header.dataRanges,
            selectedDataRangeId:
                action.payload.dataRangeId ??
                action.payload.header.dataRanges.find((e) => e.isDefault)
                    .dataRangeId,
            evalRanges: action.payload.header.evaluationRanges,
            selectedEvalRangeId:
                action.payload.evalRangeId ??
                action.payload.header.evaluationRanges.find((e) => e.isDefault)
                    .evaluationRangeId,
            drillPaths: action.payload.config.drillPaths,
            selectedDrillPathId:
                action.payload.drillPathId ??
                action.payload.config.drillPaths.find((e) => e.isDefault)
                    .identifier,
            period: determinePeriod(action.payload.table),
            hasData: nextRows?.length > 0,
            rows: nextRows,
        };
    } catch (err) {
        console.log(err);

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
                reset: undefined,
            },
        };
    }
}
